import toast from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";
import { useSetAtom } from "jotai";
import { i18n } from "@arc/i18n";
import axiosInstance from "../../api/architecton";
import { authTokenAtom } from "../../atoms/user";
export const useAuth = () => {
    const setAuthToken = useSetAtom(authTokenAtom);
    return useMutation({
        mutationFn: async (credentials) => {
            const response = await axiosInstance.post("/auth", credentials);
            return response.data;
        },
        onSuccess: (data) => {
            setAuthToken(data.access_token);
        },
        onError: () => {
            const errorMessage = i18n.isInitialized ? i18n.t("ERRORS.AUTH") : "Authentication failed";
            toast.error(errorMessage, { id: "auth-error" });
        },
    });
};
//# sourceMappingURL=useAuth.js.map